import React from "react";
import Chip from "@mui/material/Chip";
import { formatDate, formatNumber } from "../format";
import { StatCard, ComparisonBar } from "./shared";

export const InvoiceCard = ({ item, translate, money }) => (
  <div className="fleetbot-card">
    <div className="fleetbot-card-title fleetbot-card-title-row">
      {item.invoiceNumber}
      <Chip
        size="small"
        color={item.pendingAmount > 0 ? "warning" : "success"}
        label={
          item.pendingAmount > 0
            ? translate("fleetBotPendingAmount")
            : translate("fleetBotPaidAmount")
        }
        sx={{ height: 20, fontSize: 10 }}
      />
    </div>
    {item.customer ? (
      <div className="fleetbot-kv">
        <span>{translate("accountName")}</span>
        <strong>{item.customer}</strong>
      </div>
    ) : null}
    <div className="fleetbot-kv">
      <span>{translate("invoiceDate")}</span>
      <strong>{formatDate(item.date)}</strong>
    </div>
    <div className="fleetbot-kv">
      <span>{translate("fleetBotTotalAmount")}</span>
      <strong>{money(item.totalAmount)}</strong>
    </div>
    <div className="fleetbot-kv">
      <span>{translate("fleetBotPaidAmount")}</span>
      <strong>{money(item.paidAmount)}</strong>
    </div>
    <div className="fleetbot-kv">
      <span>{translate("fleetBotPendingAmount")}</span>
      <strong>{money(item.pendingAmount)}</strong>
    </div>
  </div>
);

function renderAmountPeriod(period = {}, translate, money, type, hideTitle) {
  return (
    <>
      {!hideTitle && period.label ? (
        <div className="fleetbot-section-title">{period.label}</div>
      ) : null}
      <div className="fleetbot-stats">
        <StatCard
          label={
            type === "invoices"
              ? translate("fleetBotTotalInvoices")
              : translate("fleetBotTotalDeliveryNotes")
          }
          value={formatNumber(period.totalInvoices || period.totalDeliveryNotes)}
        />
        <StatCard
          label={translate("fleetBotTotalAmount")}
          value={money(period.totalAmount)}
          accent
        />
        <StatCard
          label={translate("fleetBotPaidAmount")}
          value={money(period.paidAmount)}
        />
        <StatCard
          label={translate("fleetBotPendingAmount")}
          value={money(period.pendingAmount)}
        />
      </div>
    </>
  );
}

export function renderInvoices(questionId, data, { translate, money }) {
  if (questionId === "invoicesCurrentMonth" || questionId === "invoicesLastMonth") {
    const period =
      questionId === "invoicesCurrentMonth"
        ? data.summary?.currentMonth
        : data.summary?.lastMonth;
    const items = period?.items || [];

    return (
      <>
        <div className="fleetbot-section-title">{period?.label}</div>
        <div className="fleetbot-list">
          {items.map((item) => (
            <InvoiceCard
              key={item.id || item.invoiceNumber}
              item={item}
              translate={translate}
              money={money}
            />
          ))}
        </div>
        <div className="fleetbot-section-title">
          {translate("fleetBotInvoiceSummary")}
        </div>
        {renderAmountPeriod(period, translate, money, "invoices", true)}
        <ComparisonBar
          spent={period?.paidAmount}
          saved={period?.pendingAmount}
          spentLabel={translate("fleetBotPaidAmount")}
          savedLabel={translate("fleetBotPendingAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  if (questionId === "invoiceSummary") {
    const summary = data.summary || {};
    return (
      <>
        {summary.label ? (
          <div className="fleetbot-section-title">{summary.label}</div>
        ) : null}
        <div className="fleetbot-stats">
          <StatCard
            label={translate("fleetBotTotalInvoices")}
            value={formatNumber(summary.totalInvoices)}
          />
          <StatCard
            label={translate("fleetBotTotalAmount")}
            value={money(summary.totalAmount)}
            accent
          />
          <StatCard
            label={translate("fleetBotPaidAmount")}
            value={money(summary.paidAmount)}
          />
          <StatCard
            label={translate("fleetBotPendingAmount")}
            value={money(summary.pendingAmount)}
          />
        </div>
        <ComparisonBar
          spent={summary.paidAmount}
          saved={summary.pendingAmount}
          spentLabel={translate("fleetBotPaidAmount")}
          savedLabel={translate("fleetBotPendingAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  if (questionId === "pendingInvoices") {
    const items = data.list || [];
    const summary = data.summary || {};

    return (
      <>
        <div className="fleetbot-list">
          {items.map((item) => (
            <InvoiceCard
              key={item.id || item.invoiceNumber}
              item={item}
              translate={translate}
              money={money}
            />
          ))}
        </div>
        <div className="fleetbot-section-title">
          {translate("fleetBotInvoiceSummary")}
        </div>
        {renderAmountPeriod(summary, translate, money, "invoices", true)}
        <ComparisonBar
          spent={summary.paidAmount}
          saved={summary.pendingAmount}
          spentLabel={translate("fleetBotPaidAmount")}
          savedLabel={translate("fleetBotPendingAmount")}
          savedTone="pending"
        />
      </>
    );
  }

  return null;
}
